/* eslint-disable */
import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {
  FormEditFieldCreateDialogView,
  FormEditFieldDialogContext,
  FormEditFieldUpdateDialogView,
  FormGroupModel,
  FormModel
} from '../../../../../../../util/form/form-utils';
import {
  FieldValidationError,
  FormRef,
  LocalFieldValidationErrors,
  LocalFieldValidationErrorsFactory
} from '../../../../../../../lib/util/services';
import {Form} from '../../../../../../../lib/form/form.service';
import {InputMask} from '../../../../../../../util/input-masks';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {NgModel} from '@angular/forms';
import {FieldWidthType} from '../../../../../../../util/form/form-field-width-type';
import {
  FieldValidationType,
  FormFieldValidationTypeModel
} from '../../../../../../../util/form/form-field-validation-type';
import {List, Set} from 'immutable';
import {OptionItem, UiConstants} from '../../../../../../../util/core-utils';
import {DocumentFileService} from '../../../../../../../lib/document/document-file.service';
import {ToasterService} from '../../../../../../../fork/angular2-toaster/angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {Models} from '../../../../../../../util/model-utils';
import {Angular2Multiselects} from '../../../../../../../util/multiselect';
import {FormFieldItem} from "../../boolean/create-update/form-edit-create-update-boolean-field-dialog.component";
import FieldDataTypeSelector = Form.FieldDataTypeSelector;

/* eslint-enable */

@Component({
  selector: 'app-form-edit-create-update-stock-summary-field-dialog',
  templateUrl: './form-edit-create-update-stock-summary-field-dialog.component.html',
  styleUrls: ['./form-edit-create-update-stock-summary-field-dialog.component.scss']
})
export class FormEditCreateUpdateStockSummaryFieldDialogComponent
  implements FormEditFieldCreateDialogView, FormEditFieldUpdateDialogView, FormRef, AfterViewInit {

  public readonly selector = Form.FieldDataTypeSelector.STOCK_SUMMARY;
  public readonly createTitle = 'FORM_ITEM_CREATE_STOCK_SUMMARY_TITLE';
  public readonly updateTitle = 'FORM_ITEM_UPDATE_STOCK_SUMMARY_TITLE';
  public readonly cloneTitle = 'FORM_ITEM_CLONE_STOCK_SUMMARY_TITLE';

  InputMask = InputMask;
  Form = Form;
  UiConstants = UiConstants;

  @ViewChild('fieldDialog', {static: true})
  dialogComponent: ModalDirective;

  @ViewChild('title')
  titleInput: NgModel;

  @ViewChild('api_export_name')
  apiExportNameInput: NgModel;

  @ViewChild('summarized_fields')
  summarizedFieldsInput: NgModel;

  visible: boolean = false;
  fieldModel: Model = new Model();
  dialogTitleDictionaryKey: string = '';
  latestApiExportName = '';

  fieldWidthTypes: FieldWidthType[] = FieldWidthType.VALUES.toArray();
  fieldValidationTypes: Form.FormFieldValidationType[] = FieldValidationType.VALUES.toArray();

  private fieldErrors: FieldValidationError<Form.FieldValidatedField> =
    FieldValidationError.empty<Form.FieldValidatedField>();

  private validatedInputs: LocalFieldValidationErrors<NgModel> =
    LocalFieldValidationErrorsFactory.empty();

  private context: FormEditFieldDialogContext;
  private group: FormGroupModel;
  private field?: Form.Field;
  private clone?: boolean;
  private submitted: boolean = false;

  formFieldItemsToSummarize: FormFieldItem[] = [];

  dropdownSettings?: Angular2Multiselects.Settings;

  getForm() {
    return {
      submitted: this.submitted
    };
  }

  public constructor() {
  }

  ngAfterViewInit(): void {
    this.loadLocalFieldValidationErrors();
    this.initDropdownSettings();
  }

  initDropdownSettings() {
    this.dropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(false)
      .enableSearchFilter(true)
      .enableCheckAll(false)
      .remoteSearch(false)
      .labelKey(OptionItem.KEY_TEXT)
      .build();
  }

  registerContext(context: FormEditFieldDialogContext): void {
    this.context = context;
  }

  showDialog(form: FormModel, group: FormGroupModel, field?: Form.Field, clone?: boolean): void {
    this.latestApiExportName = '';
    this.visible = true;
    this.clone = clone;
    this.loadFieldsAndShowDialog(form, group, field, clone);
  }

  onModalHide(event: ModalDirective) {
    if (event.dismissReason === 'backdrop-click' || event.dismissReason === 'esc') {
      this.visible = false;
      this.submitted = false;
      this.fieldModel = new Model();
    }
  }

  closeDialog(): void {
    this.visible = false;
    this.submitted = false;
    this.dialogComponent.hide();
    this.fieldModel = new Model();
    this.formFieldItemsToSummarize = [];
  }

  saveField() {
    this.submitted = true;
    if (this.hasLocalFieldError(this.titleInput)
      || this.hasLocalFieldError(this.apiExportNameInput)
      || this.hasLocalFieldError(this.summarizedFieldsInput)) {
      return;
    }
    if (this.field && this.clone) {
      this.createField();
    } else if (this.field) {
      this.updateField(this.field);
    } else {
      this.createField();
    }
  }

  hasLocalFieldError(field?: NgModel): boolean {
    return this.validatedInputs.hasLocalError(field);
  }

  hasFieldError(field?: Form.FieldValidatedField): boolean {
    return this.fieldErrors.hasError(field);
  }

  removeFieldError(field: Form.FieldValidatedField) {
    this.fieldErrors = this.fieldErrors.removeError(field);
  }

  getFieldErrorText(field: Form.FieldValidatedField): string {
    return this.fieldErrors.getErrorText(field);
  }

  getFieldValidationTypeDictionaryKey(vt: Form.FormFieldValidationType): string {
    return FieldValidationType.getFieldValidationTypeDictionaryKey(vt);
  }

  onAdminFormFieldValidationTypeChanged() {
    FieldValidationType.onAdminFormFieldValidationTypeChanged(this.fieldModel);
  }

  onMobileFormFieldValidationTypeChanged() {
    FieldValidationType.onMobileFormFieldValidationTypeChanged(this.fieldModel);
  }

  private loadLocalFieldValidationErrors() {
    const validatedInputs = List.of(this.titleInput, this.apiExportNameInput);
    this.validatedInputs = LocalFieldValidationErrorsFactory.ofFields(this, validatedInputs);
  }

  private loadFieldsAndShowDialog(form: FormModel, group: FormGroupModel, field?: Form.Field, clone?: boolean) {
    this.group = group;
    const fieldsToBeSummarized = this.createFieldsToSummarize(form);
    if (field && clone) {
      this.dialogTitleDictionaryKey = this.cloneTitle;
      this.loadField(field, fieldsToBeSummarized);
    } else if (field) {
      this.dialogTitleDictionaryKey = this.updateTitle;
      this.loadField(field, fieldsToBeSummarized);
    } else {
      this.dialogTitleDictionaryKey = this.createTitle;
    }
    this.formFieldItemsToSummarize = this.filterFieldsToSummarize(fieldsToBeSummarized);
    this.dialogComponent.show();
  }

  private loadField(field: Form.Field, fieldsToBeSummarized: FormFieldItem[]) {
    this.field = field;
    const attrs = field.dataType.stockSummaryAttributes!;
    const fieldWidth = FieldWidthType.fromPercentValue(field.formFieldWidthPercent);
    this.fieldModel.title = field.title;
    this.fieldModel.description = field.description ? field.description : '';
    this.fieldModel.apiExportName = field.apiExportName ? field.apiExportName : '';
    this.fieldModel.pdfExportName = field.pdfExportName ? field.pdfExportName : '';
    this.fieldModel.displayOnNewRow = field.displayOnNewRow;
    this.fieldModel.fieldWidthType = fieldWidth ? fieldWidth : FieldWidthType.FULL_SCREEN;
    this.fieldModel.adminFormFieldValidationType = field.admin.validationType;
    this.fieldModel.helpdeskFormFieldValidationType = field.helpdesk.validationType;
    this.fieldModel.mobileFormFieldValidationType = field.mobile.validationType;
    this.setSummarizedFormFields(attrs.summarizedFields, fieldsToBeSummarized);
  }

  private setSummarizedFormFields(summarizedFields: Set<number>, fieldsToBeSummarized: FormFieldItem[]) {
    this.fieldModel.fieldsToBeSummarized = this.fieldIdsToFieldItems(fieldsToBeSummarized, summarizedFields.toArray());
  }

  private createField() {
    this.context.formService.createField({
      parentId: this.context.parentId,
      groupId: this.group.groupId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      displayOnNewRow: this.fieldModel.displayOnNewRow
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private updateField(field: Form.Field) {
    this.context.formService.updateField({
      parentId: this.context.parentId,
      groupId: this.group.groupId,
      fieldId: field.fieldId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      displayOnNewRow: this.fieldModel.displayOnNewRow
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private getDataTypeRequest(): Form.FieldDataType {
    return {
      stockSummaryAttributes: {
        summarizedFields: Set.of(...this.fieldItemsToFieldIds(this.fieldModel.fieldsToBeSummarized))
      }
    };
  }

  private createFieldsToSummarize(form: FormModel): FormFieldItem[] {
    const items: FormFieldItem[] = [];
    form.formGroups.forEach(g => {
      g.fields.forEach(f => {
        items.push({
          id: f.fieldId,
          text: f.title,
          itemSubtitle: g.title + ' (' + g.groupId + ')',
          field: f,
        });
      });
    });
    return items;
  }

  private filterFieldsToSummarize(items: FormFieldItem[]): FormFieldItem[] {
    const filtered: FormFieldItem[] = [];
    items.forEach(item => {
      if (!this.field || (this.field && item.field.fieldId !== this.field.fieldId)) {
        if (item.field.dataTypeSelector === FieldDataTypeSelector.STOCK) {
          filtered.push(item);
        }
      }
    });
    return filtered;
  }

  fieldIdsToFieldItems(items: FormFieldItem[], values: number[]): FormFieldItem[] {
    const ret: FormFieldItem[] = [];
    values.forEach(id => {
      const item: FormFieldItem | undefined = items.find(f => {
        return id === f.id;
      });
      if (item) {
        ret.push(item);
      }
    });
    return ret;
  }

  fieldItemsToFieldIds(values: FormFieldItem[]): number[] {
    const ret: number[] = [];
    values.forEach(f => {
      if (f.id) {
        ret.push(f.id);
      }
    });
    return ret;
  }


  onTitleBlur() {
    const normalizedText = Models.normalizeText(this.fieldModel.title);
    if (this.fieldModel.apiExportName === '') {
      this.fieldModel.apiExportName = normalizedText;
    }
    if (this.fieldModel.pdfExportName === '') {
      this.fieldModel.pdfExportName = normalizedText;
    }
  }

}

export class Model implements FormFieldValidationTypeModel {
  title: string = '';
  description: string = '';
  apiExportName: string = '';
  pdfExportName: string = '';
  displayOnNewRow: boolean = true;
  fieldWidthType: FieldWidthType = FieldWidthType.DEFAULT;
  adminVisibleOnFormDetail: boolean = true;
  mobileVisibleOnFormDetail: boolean = true;
  mobileVisibleOnMasterDetail: boolean = false;
  adminFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  helpdeskFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  mobileFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  multiSelect: boolean = false;
  fieldsToBeSummarized: FormFieldItem[] = [];
}
